import { DatePickerProps } from "@mui/x-date-pickers";
import { format } from "date-fns";
import dayjs, { Dayjs } from "dayjs";

export const getYYYYMMDD = (date: Date) => {
    if (!date) return;
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${date.getFullYear()}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
};

export const getMMMDDYYYY = (dateString: string): string => {
    return dayjs(dateString).format('MMM DD, YYYY');
};

export const getCurrentDateString = () => {
    const currentDate = new Date();
    return  currentDate.toISOString().split('T')[0];
}

export const formatDateAs = (dateReceived: Date|undefined|null, dateFormat: string): string => {
    if (dateReceived)
        return format(dateReceived, dateFormat);
    else
        return "--";
}

export const validateDate = (date: Date|undefined|null, fieldName: string, minDate: Dayjs|null|undefined, minDateErrMsg: string|undefined, maxDate: Dayjs|null|undefined, maxDateErrMsg: string|undefined): true | string | undefined => {
    if (!date) return true;
    const formattedDate = dayjs(date);

    if (!formattedDate.isValid()) {
        return `Invalid Date. Please enter a valid ${fieldName}.`;
    }

    if (minDate && formattedDate.isBefore(minDate, 'day')) {
        console.log(minDate)
        return minDateErrMsg;
    }

    if (maxDate && formattedDate.isAfter(maxDate, 'day')) {
        return maxDateErrMsg;
    }
    return true;
};

export const validateDate2 = (date: Date|undefined|null, fieldName: string, dateMin: Date|null|undefined, minDateErrMsg: string|undefined, dateMax: Date|null|undefined, maxDateErrMsg: string|undefined): true | string | undefined => {
    if (!date) return true;

    const minDate = dateMin ? dayjs(dateMin) : undefined;
    const maxDate = dateMax ? dayjs(dateMax) : undefined;
    const formattedDate = dayjs(date);

    if (!formattedDate.isValid()) {
        return `Invalid Date. Please enter a valid ${fieldName}.`;
    }

    if (minDate && formattedDate.isBefore(minDate, 'day')) {
        return minDateErrMsg;
    }

    if (maxDate && formattedDate.isAfter(maxDate, 'day')) {
        return maxDateErrMsg;
    }
    return true;
};

export const nullableDatesAreSame = (date1: Date|null|undefined, date2: Date|null|undefined): boolean => {
    return (!date1 && !date2) || dayjs(date1).isSame(date2, "day");
}

export const getDatePickerProps = (trigger: (name: string) => void, fieldName: string): Partial<DatePickerProps> => ({
  views: ['year', 'month', 'day'] as const,
  onError: () => trigger(fieldName),
}); 

type ConvertibleDateValue = dayjs.ConfigType | { $d: dayjs.ConfigType };

export const convertToDayjsValue = (value: ConvertibleDateValue): Dayjs | null => {
    if (!value) return null;
    if (typeof value === 'object' && '$d' in value) {
        return dayjs(value.$d);
    }
    return dayjs(value);
};

export const addDaysToDate = (startDate: Date, daysToAdd: number): Date => {
    if (!startDate) {
        throw new Error('Start date is required');
    }
    
    const resultDate = new Date(startDate);
    resultDate.setDate(resultDate.getDate() + daysToAdd);
    return resultDate;
};



